import Cell from './Cell';
import Head from './Head';
import Row from './Row';
var DatePickerPlugin = /*@__PURE__*/ (function () {
    function DatePickerPlugin(element) {
        this.nextEnabled = true;
        this.prevEnabled = false;
        this.element = element;
        this.cells = [];
        this.enabledDates = false;
        this.head = new Head(jQuery(element).find('.fm-table-header').get(0));
        this.today = new Date();
        this.maxDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 30);
        this.setCurrentDate(new Date());
        this.registerEvents();
        this.render();
    }
    DatePickerPlugin.prototype.setCurrentDate = function (date) {
        var prevDate = this.currentDate || new Date();
        var prevDay = prevDate.getDate();
        var nextDay = date.getDate();
        var prevMonth = prevDate.getMonth();
        var nextMonth = date.getMonth();
        var prevYear = prevDate.getFullYear();
        var nextYear = date.getFullYear();
        this.currentDate = date;
        if (this.currentDate.getTime() <= this.today.getTime()) {
            this.disablePrevious();
        }
        else {
            this.enablePrevious();
        }
        if (this.currentDate.getTime() + 1000 * 60 * 60 * 24 * 29 >= this.maxDate.getTime()) {
            this.disableNext();
        }
        else {
            this.enableNext();
        }
        if (prevYear !== nextYear) {
            this.renderHead();
            this.renderCells();
        }
        if (prevMonth !== nextMonth) {
            this.renderHead();
            this.renderCells();
        }
    };
    DatePickerPlugin.prototype.enableDates = function (dates) {
        this.enabledDates = dates;
        var lastDate = this.enabledDates[this.enabledDates.length - 1];
        lastDate = lastDate.split('.');
        if (this.currentDate.getTime() <= this.today.getTime()) {
            this.disablePrevious();
        }
        else {
            this.enablePrevious();
        }
        if (this.currentDate.getTime() + 1000 * 60 * 60 * 24 * 29 >= this.maxDate.getTime()) {
            this.disableNext();
        }
        else {
            this.enableNext();
        }
        this.render();
    };
    DatePickerPlugin.prototype.render = function () {
        this.renderHead();
        this.renderCells();
    };
    DatePickerPlugin.prototype.renderHead = function () {
        this.head.updateMonth(this.currentDate.getMonth(), this.currentDate.getFullYear());
    };
    DatePickerPlugin.prototype.renderCells = function () {
        var _this = this;
        jQuery(this.element).find('[data-cell-items]').html('');
        for (var _i = 0, _a = this.cells; _i < _a.length; _i++) {
            var cell = _a[_i];
            cell.remove();
        }
        this.cells = [];
        // currentDate is always the first day of the displayed month
        // getMonth => January gives 0)
        var previousMonth = this.currentDate.getMonth();
        if (0 == previousMonth) {
            previousMonth = 12;
        }
        var currentMonth = this.currentDate.getMonth() + 1;
        var nextMonth = this.currentDate.getMonth() + 2;
        // getDate returns the day of the month
        var totalDaysInCurrentMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0).getDate();
        // weekday of the first day of the displayed month
        // sunday is 0
        var weekdayFirstDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1).getDay();
        var lastDayLastMonth = new Date(this.currentDate.getFullYear(), previousMonth, 0).getDate();
        if (weekdayFirstDay === 0) {
            weekdayFirstDay = 7; // moving sunday to last position
        }
        // displayed days that belong to the previous month
        var padding = weekdayFirstDay - 1;
        // init cells for the padding days
        var firstDispayedDay = lastDayLastMonth - padding + 1;
        for (var day = firstDispayedDay; day <= lastDayLastMonth; day++) {
            var cell = new Cell(day, previousMonth);
            cell.onClick(function (day, month) {
                _this.activateCell(day, month);
            });
            this.cells.push(cell);
        }
        // init the cells for all days of the displayed month
        for (var day = 1; day <= totalDaysInCurrentMonth; day++) {
            var cell = new Cell(day, currentMonth);
            cell.onClick(function (day, month) {
                _this.activateCell(day, month);
            });
            this.cells.push(cell);
        }
        var currentRow = new Row();
        var iterations = DatePickerPlugin.CELLS_PER_ROW * DatePickerPlugin.TOTAL_ROWS;
        var _loop_1 = function (i) {
            if ((i + 7) % 7 === 0) {
                if (i > 0) {
                    jQuery(this_1.element)
                        .find('[data-cell-items]')
                        .append(jQuery(currentRow.getElement()));
                }
                currentRow = new Row();
            }
            if (i < padding) {
                var dayToBeDisplayed_1 = firstDispayedDay + i;
                var currentCell = this_1.cells.filter(function (cell) { return cell.day === dayToBeDisplayed_1 && cell.month === previousMonth; });
                if (0 < currentCell.length) {
                    var dateString = this_1.transform2Digits(dayToBeDisplayed_1) + "." + this_1.transform2Digits(previousMonth) + "." + this_1.currentDate.getFullYear();
                    if (this_1.enabledDates) {
                        if (this_1.enabledDates.indexOf(dateString) > -1) {
                            currentCell[0].enable();
                        }
                        else {
                            currentCell[0].disable();
                        }
                    }
                    currentRow.addCell(currentCell[0]);
                }
            }
            else if (i - padding + 1 > totalDaysInCurrentMonth) {
                var virtualCell = new Cell(i + 1 - padding - totalDaysInCurrentMonth, nextMonth);
                virtualCell.disable();
                currentRow.addCell(virtualCell);
            }
            else {
                var dayToBeDisplayed_2 = i - padding + 1;
                var currentCell = this_1.cells.filter(function (cell) { return cell.day === dayToBeDisplayed_2 && cell.month === currentMonth; });
                if (0 < currentCell.length) {
                    var dateString = this_1.transform2Digits(dayToBeDisplayed_2) + "." + this_1.transform2Digits(currentMonth) + "." + this_1.currentDate.getFullYear();
                    if (this_1.enabledDates) {
                        if (this_1.enabledDates.indexOf(dateString) > -1) {
                            currentCell[0].enable();
                        }
                        else {
                            currentCell[0].disable();
                        }
                    }
                    currentRow.addCell(currentCell[0]);
                }
            }
            if (i === iterations - 1) {
                if (i > 0) {
                    jQuery(this_1.element)
                        .find('[data-cell-items]')
                        .append(jQuery(currentRow.getElement()));
                }
            }
        };
        var this_1 = this;
        for (var i = 0; i < iterations; i++) {
            _loop_1(i);
        }
    };
    DatePickerPlugin.prototype.registerEvents = function () {
        var _this = this;
        var nextHandle = jQuery(this.element).find('[data-next-handle]');
        nextHandle.off('click').on('click', function () {
            _this.nextMonth();
        });
    };
    DatePickerPlugin.prototype.previousMonth = function () {
        var nextDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
        this.setCurrentDate(nextDate);
    };
    DatePickerPlugin.prototype.nextMonth = function () {
        var nextDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
        this.setCurrentDate(nextDate);
    };
    DatePickerPlugin.prototype.disablePrevious = function () {
        this.prevEnabled = false;
        jQuery(this.element)
            .find('[data-prev-handle]')
            .css({
            opacity: 0,
            cursor: 'initial'
        })
            .off('click');
    };
    DatePickerPlugin.prototype.enablePrevious = function () {
        var _this = this;
        this.prevEnabled = true;
        jQuery(this.element)
            .find('[data-prev-handle]')
            .css({
            opacity: 'inherit',
            cursor: 'pointer'
        })
            .off('click')
            .on('click', function () {
            _this.previousMonth();
        });
    };
    DatePickerPlugin.prototype.disableNext = function () {
        this.nextEnabled = false;
        jQuery(this.element)
            .find('[data-next-handle]')
            .css({
            opacity: 0,
            cursor: 'initial'
        })
            .off('click');
    };
    DatePickerPlugin.prototype.enableNext = function () {
        var _this = this;
        this.nextEnabled = true;
        jQuery(this.element)
            .find('[data-next-handle]')
            .css({
            opacity: 'inherit',
            cursor: 'pointer'
        })
            .off('click')
            .on('click', function () {
            _this.nextMonth();
        });
    };
    DatePickerPlugin.prototype.activateFirstDateCell = function () {
        for (var i in this.cells) {
            if (this.cells[i].isEnabled()) {
                this.activateCell(this.cells[i].day, this.cells[i].month);
                break;
            }
        }
    };
    DatePickerPlugin.prototype.activateCell = function (day, month) {
        for (var _i = 0, _a = this.cells; _i < _a.length; _i++) {
            var cell = _a[_i];
            cell.deactivate();
        }
        var currentCell = this.cells.filter(function (cell) { return cell.day === day && cell.month === month; });
        if (0 < currentCell.length) {
            currentCell[0].activate();
            // new Date: the month is 0-indexed
            this.selectedDate = new Date(this.currentDate.getFullYear(), month - 1, day);
            var weekday = this.selectedDate.getDay();
            var weekdayDisplay = DatePickerPlugin.DAYS[weekday];
            var monthDisplay = DatePickerPlugin.MONTHS[month - 1];
            var label = weekdayDisplay + ", " + day + ". " + monthDisplay;
            if (this.selectEvt) {
                this.selectEvt(this.selectedDate, label);
            }
            // set date
            var element = document.getElementById('timeslot-date');
            element.innerHTML = this.transform2Digits(day) + "." + this.transform2Digits(month) + "." + this.currentDate.getFullYear() + ", ";
        }
    };
    DatePickerPlugin.createDateLabel = function (dateObject) {
        var day = dateObject.getDay();
        day = DatePickerPlugin.DAYS[day];
        var month = dateObject.getMonth();
        month = DatePickerPlugin.MONTHS[month];
        var date = dateObject.getDate();
        var label = day + ", " + date + ". " + month;
        return label;
    };
    DatePickerPlugin.prototype.onDateChange = function (callback) {
        this.selectEvt = callback;
    };
    DatePickerPlugin.prototype.transform2Digits = function (decimal) {
        var formattedNumber = ("0" + decimal.toString()).slice(-2);
        return formattedNumber;
    };
    DatePickerPlugin.CELLS_PER_ROW = 7;
    DatePickerPlugin.TOTAL_ROWS = 5;
    DatePickerPlugin.DAYS = [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa',
    ];
    DatePickerPlugin.MONTHS = [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ];
    return DatePickerPlugin;
}());
export default DatePickerPlugin;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/plugins/DatePicker/index.ts
// module id = null
// module chunks = 